import Loadable from 'react/components/loadable';

const CloseUnsavedFormModal = Loadable({
  loader: () => import('react/components/close_unsaved_form_modal'),
  type: 'modal',
});

angular.module('gym').value('CloseUnsavedFormModal', CloseUnsavedFormModal);
